import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-pending',
  templateUrl: './icon-pending.component.html',
  styles: []
})
export class IconPendingComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
